// ----------------------------------------------------------------------

export const navSectionClasses = {
  ul: 'nav-section-ul',
  li: 'nav-section-li',
  item: {
    root: 'nav-section-item-root',
    title: 'nav-section-item-title',
    icon: 'nav-section-item-icon',
    arrow: 'nav-section-item-arrow',
  },
  state: {
    open: 'nav-section-state-open',
    active: 'nav-section-state-active',
  },
};

import type { ReactNode } from 'react';

export const createNavItem = ({
  path,
  icon,
  hasChild,
  externalLink,
}: {
  path: string;
  icon?: string | ReactNode;
  hasChild?: boolean;
  externalLink?: boolean;
}) => {
  const baseProps = {
    href: path || '#',
    ...(hasChild && { component: 'button' }),
    ...(externalLink && { target: '_blank', rel: 'noopener' }),
  };

  const renderIcon = icon || null;

  return {
    baseProps,
    renderIcon,
  };
};
